// TODO: As spoken with Eze, this should be a component not related to coupons
// General expandable card not composed of ul and li but of divs
// Please, update me
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

class List extends React.Component {
  constructor(props) {
    super(props);

    const { expanded } = this.props;

    this.state = { expanded };
    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    const { expandable } = this.props;
    const { expanded } = this.state;

    if (!expandable) {
      return;
    }

    this.setState({
      expanded: !expanded,
    });
  }

  render() {
    const {
      expandable, hasHeader, header, children,
    } = this.props;

    const { expanded } = this.state;

    const className = classnames('bvs-card coupon-list', {
      expandable,
      open: expanded,
    });

    return (
      <ul className={className}>
        {hasHeader && (
          <li className="list-header coupon-header-wrapper" onClick={this.toggle}>
            <div className="bvs-card__header coupon-header">
              <p className="coupon-header-title">{header}</p>
              {
                expandable
                && <div className="coupon-header-icons"><span className="expandable-icon" /></div>
              }
            </div>
          </li>
        )}
        { (!expandable || expanded) && children }
      </ul>
    );
  }
}

List.propTypes = {
  header: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  expanded: PropTypes.bool,
  expandable: PropTypes.bool,
  hasHeader: PropTypes.bool,
};

List.defaultProps = {
  expanded: false,
  expandable: false,
  hasHeader: true,
};

export default List;
